import "./CoverButton.css";

type Props = {
	/**
	 * The button's accessible name. It has no content of its own, so there is
	 * nothing else for a screen reader to announce.
	 */
	label: string;
	onActivate: (event: MouseEvent) => void;
	class?: string;
	disabled?: boolean;
};

/**
 * A transparent button filling its nearest positioned ancestor, so that a whole
 * tile activates without wrapping the tile's own controls in a button — which
 * is invalid HTML, and leaves those controls fighting the outer handler with
 * `stopPropagation`.
 *
 * It belongs early among its siblings: later positioned siblings paint (and so
 * hit-test) above it, which is what keeps the controls over a cover clickable.
 * Anything between them that is not itself a control should be transparent to
 * the pointer, or it will swallow the clicks meant for this button.
 */
export const CoverButton = (props: Props) => (
	<button
		type="button"
		class={`gvtui-cover gvtui-cover-button ${props.class ?? ""}`}
		aria-label={props.label}
		disabled={props.disabled}
		onClick={(event) => {
			props.onActivate(event);
		}}
	/>
);
